import { useMutation, UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

type CreateActivityDto = {
  name: string
}

export const useCreateActivityMutation = (
  options?: UseMutationOptions<string, AxiosError, CreateActivityDto>
) =>
  useMutation<string, AxiosError, CreateActivityDto>({
    ...options,
    mutationFn: async (data) => {
      const res = await httpClient.post("/admin/activity", data)
      return res.data
    },
    onSuccess: async (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      await queryClient.invalidateQueries({
        queryKey: ["findAllActivities"],
      })
      showSuccessNotification({
        title: "Added",
        message: "Successfully added activity",
      })
    },
    onError: (error, variables, onMutateResult, context) => {
      options?.onError?.(error, variables, onMutateResult, context)
      showAxiosError({
        defaultMessage: "Failed to add activity",
        showNotification: true,
        error,
      })
    },
  })
